
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-table-column-header',
    templateUrl: './table-column-header.component.html',
    styles: [`
        .dropdown-toggle::after { display: none !important; }
        :host { display: table-cell; vertical-align: inherit; font-weight: bold; }
    `]
})
export class TableColumnHeaderComponent {
    @Input() label: string = '';
    @Input() field: string = '';
    @Input() isFilterActive: boolean = false;

    // For Checkbox List Filter
    @Input() filterValues: string[] = [];
    @Input() activeFilterSet: Set<string> | undefined;

    // For Text Filter (Title)
    @Input() isTextFilter: boolean = false;
    @Input() currentTitleFilter: string = '';

    // Config
    @Input() isDate: boolean = false;

    @Output() sort = new EventEmitter<boolean>(); // true=desc, false=asc
    @Output() filterChange = new EventEmitter<{ value: string, checked: boolean }>();
    @Output() titleFilterChange = new EventEmitter<string>();
    @Output() clear = new EventEmitter<void>();
    @Output() selectAll = new EventEmitter<boolean>();

    searchTerm: string = '';

    // Computed values for the list
    get displayedValues(): string[] {
        if (!this.searchTerm) return this.filterValues;
        const lower = this.searchTerm.toLowerCase();
        return this.filterValues.filter(v => (v || '').toLowerCase().includes(lower));
    }

    get isAllSelected(): boolean {
        // If filter set is undefined/null, it implies "All selected" (no filter applied)
        return !this.activeFilterSet;
    }

    onSelectAll(event: any): void {
        this.selectAll.emit(event.target.checked);
    }

    onClear(): void {
        this.searchTerm = '';
        this.clear.emit();
    }

    onDropdownOpenChange(isOpen: boolean): void {
        if (!isOpen) {
            this.searchTerm = '';
        }
    }

    onSort(desc: boolean): void {
        this.sort.emit(desc);
    }

    onCheckChange(value: string, event: any): void {
        this.filterChange.emit({ value, checked: event.target.checked });
    }

    onTitleChange(val: string): void {
        this.titleFilterChange.emit(val);
    }

    isChecked(value: string): boolean {
        // If filterSet is null/undefined, it usually means "All Selected" in the parent logic
        if (!this.activeFilterSet) return true;
        return this.activeFilterSet.has(value);
    }
}
